function updateNostolaatikotColumnHeights() {
    // Select all .nosto-column elements inside .nostolaatikot
    const nostoColumns = document.querySelectorAll('.nostolaatikot .nosto-column');


    if (nostoColumns.length > 0) {
        // Loop through each .nosto-column element
        nostoColumns.forEach(function(column) {
            // Get the computed width of the column
            const width = window.getComputedStyle(column).width;

            // Set the height of the column to match its width
            column.style.height = width;
        });
    }
}
document.addEventListener('DOMContentLoaded', function() {
    // Initial update
    updateNostolaatikotColumnHeights();

    // Update heights on window resize
    window.addEventListener('resize', updateNostolaatikotColumnHeights);
});
